import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface Props {
  label: string
  collapsed?: boolean
  children: ReactNode
}

const SidebarSection: React.FC<Props> = ({ label, collapsed, children }) => (
  <Section>
    <SectionHead $collapsed={!!collapsed}>
      {!collapsed && <Label>{label}</Label>}
    </SectionHead>
    {children}
  </Section>
)

export default SidebarSection

const Section = styled.div`
  margin-top: 16px;

  &:first-child {
    margin-top: 6px;
  }
`

const SectionHead = styled.div<{ $collapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 8px;
  height: ${({ $collapsed }) => ($collapsed ? '12px' : '22px')};

  ${({ $collapsed, theme }) =>
    $collapsed &&
    `
      padding: 0 12px 6px;
      justify-content: center;

      &::before {
        content: '';
        height: 1px;
        width: 100%;
        background: ${theme.colors.line};
      }
    `}
`

const Label = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 10px;
  color: ${({ theme }) => theme.colors.ink3};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  white-space: nowrap;
`
